module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Electric/Fan-c7dfccf84a95725bb4ae1b059914f93972c09a757390760b368673d4bba164eb.svg";